module.exports = __webpack_public_path__ + "static/media/UN.b38bbeae.png";